import { useState } from 'react';

const useFormValidation = (form, getErrorMessage) => {
    const [errors, setErrors] = useState(Object.keys(form).reduce((acc, cur) => ({ ...acc, [cur]: '' }), {}));

    const validate = (key, value, form) => {
        const errorMessage = getErrorMessage(key, value, form);
        setErrors((errors) => {
            return {
                ...errors,
                [key]: errorMessage,
            };
        });
    };

    const validateAll = () => {
        return !Boolean(
            Object.keys(errors)
                .map((key) => {
                    validate(key, form[key], form);
                    return getErrorMessage(key, form[key], form) || '';
                })
                .reduce((cur, acc) => {
                    return cur + acc;
                }, '')
        );
    };

    return {
        errors,
        validate,
        validateAll,
    };
};

export default useFormValidation;
